"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Export_eventEngine, _Export_id, _Export_inputValidator, _Export_logger, _Export_name, _Export_session, _Export_sessionEngine, _Export_type, _Export_uuidGenerator, _Export_content, _Export_delay, _Export_dependency, _Export_displayname, _Export_filename, _Export_group, _Export_hidden, _Export_maxWaitTime, _Export_msg, _Export_order, _Export_result, _Export_status_collect, _Export_status_computation, _Export_tooltip, _Export_uid, _Export_version;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Export = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const tsyringe_1 = require("tsyringe");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
class Export {
    // #endregion Properties (21)
    // #region Constructors (1)
    constructor(session, sessionEngine, exportDef) {
        // #region Properties (21)
        _Export_eventEngine.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.EventEngine));
        _Export_id.set(this, void 0);
        _Export_inputValidator.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.InputValidator));
        _Export_logger.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.Logger));
        _Export_name.set(this, void 0);
        _Export_session.set(this, void 0);
        _Export_sessionEngine.set(this, void 0);
        _Export_type.set(this, void 0);
        _Export_uuidGenerator.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.UuidGenerator));
        _Export_content.set(this, void 0);
        _Export_delay.set(this, void 0);
        _Export_dependency.set(this, void 0);
        _Export_displayname.set(this, void 0);
        _Export_filename.set(this, void 0);
        _Export_group.set(this, void 0);
        _Export_hidden.set(this, false);
        _Export_maxWaitTime.set(this, 300000);
        _Export_msg.set(this, void 0);
        _Export_order.set(this, void 0);
        _Export_result.set(this, void 0);
        _Export_status_collect.set(this, void 0);
        _Export_status_computation.set(this, void 0);
        _Export_tooltip.set(this, void 0);
        _Export_uid.set(this, void 0);
        _Export_version.set(this, void 0);
        try {
            __classPrivateFieldSet(this, _Export_session, session, "f");
            __classPrivateFieldSet(this, _Export_sessionEngine, sessionEngine, "f");
            __classPrivateFieldSet(this, _Export_id, exportDef.id, "f");
            __classPrivateFieldSet(this, _Export_name, exportDef.name, "f");
            __classPrivateFieldSet(this, _Export_type, exportDef.type, "f");
            this.updateExportDefinition(exportDef);
            __classPrivateFieldGet(this, _Export_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).constructor: Initialized export ${JSON.stringify(exportDef)}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Export_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${exportDef.id}).constructor`, e);
        }
    }
    // #endregion Constructors (1)
    // #region Public Accessors (21)
    get content() {
        return __classPrivateFieldGet(this, _Export_content, "f");
    }
    get delay() {
        return __classPrivateFieldGet(this, _Export_delay, "f");
    }
    get dependency() {
        return __classPrivateFieldGet(this, _Export_dependency, "f");
    }
    get displayname() {
        return __classPrivateFieldGet(this, _Export_displayname, "f");
    }
    set displayname(value) {
        try {
            __classPrivateFieldGet(this, _Export_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).displayname: Updating DisplayName to ${value}.`);
            __classPrivateFieldGet(this, _Export_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).displayname`, value, 'string', false);
            __classPrivateFieldSet(this, _Export_displayname, value, "f");
            __classPrivateFieldGet(this, _Export_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).displayname: DisplayName was updated to ${this.displayname}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Export_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).displayname`, e);
        }
    }
    get filename() {
        return __classPrivateFieldGet(this, _Export_filename, "f");
    }
    get group() {
        return __classPrivateFieldGet(this, _Export_group, "f");
    }
    get hidden() {
        return __classPrivateFieldGet(this, _Export_hidden, "f");
    }
    set hidden(value) {
        try {
            __classPrivateFieldGet(this, _Export_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).hidden: Updating Hidden to ${value}.`);
            __classPrivateFieldGet(this, _Export_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).hidden`, value, 'boolean');
            __classPrivateFieldSet(this, _Export_hidden, value, "f");
            __classPrivateFieldGet(this, _Export_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).hidden: Hidden was updated to ${this.hidden}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Export_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).hidden`, e);
        }
    }
    get id() {
        return __classPrivateFieldGet(this, _Export_id, "f");
    }
    get maxWaitTime() {
        return __classPrivateFieldGet(this, _Export_maxWaitTime, "f");
    }
    set maxWaitTime(value) {
        try {
            __classPrivateFieldGet(this, _Export_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).maxWaitTime: Updating maxWaitTime to ${value}.`);
            __classPrivateFieldGet(this, _Export_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).maxWaitTime`, value, 'number');
            __classPrivateFieldSet(this, _Export_maxWaitTime, value, "f");
            __classPrivateFieldGet(this, _Export_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).maxWaitTime: maxWaitTime was updated to ${this.maxWaitTime}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Export_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).maxWaitTime`, e);
        }
    }
    get msg() {
        return __classPrivateFieldGet(this, _Export_msg, "f");
    }
    get name() {
        return __classPrivateFieldGet(this, _Export_name, "f");
    }
    get order() {
        return __classPrivateFieldGet(this, _Export_order, "f");
    }
    set order(value) {
        try {
            __classPrivateFieldGet(this, _Export_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).order: Updating Order to ${value}.`);
            __classPrivateFieldGet(this, _Export_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).order`, value, 'number', false);
            __classPrivateFieldSet(this, _Export_order, value, "f");
            __classPrivateFieldGet(this, _Export_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).order: Order was updated to ${this.order}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Export_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).order`, e);
        }
    }
    get result() {
        return __classPrivateFieldGet(this, _Export_result, "f");
    }
    get status_collect() {
        return __classPrivateFieldGet(this, _Export_status_collect, "f");
    }
    get status_computation() {
        return __classPrivateFieldGet(this, _Export_status_computation, "f");
    }
    get tooltip() {
        return __classPrivateFieldGet(this, _Export_tooltip, "f");
    }
    set tooltip(value) {
        try {
            __classPrivateFieldGet(this, _Export_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).tooltip: Updating tooltip to ${value}.`);
            __classPrivateFieldGet(this, _Export_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).tooltip`, value, 'string', false);
            __classPrivateFieldSet(this, _Export_tooltip, value, "f");
            __classPrivateFieldGet(this, _Export_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).tooltip: tooltip was updated to ${this.tooltip}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Export_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).tooltip`, e);
        }
    }
    get type() {
        return __classPrivateFieldGet(this, _Export_type, "f");
    }
    get uid() {
        return __classPrivateFieldGet(this, _Export_uid, "f");
    }
    get version() {
        return __classPrivateFieldGet(this, _Export_version, "f");
    }
    // #endregion Public Accessors (21)
    // #region Public Methods (2)
    request(parameters = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const eventId = __classPrivateFieldGet(this, _Export_uuidGenerator, "f").create();
            try {
                const event = { type: viewer_shared_types_1.TASKTYPE.EXPORT_REQUEST, id: eventId, progress: 0, status: 'Requesting export' };
                __classPrivateFieldGet(this, _Export_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_START, event);
                __classPrivateFieldGet(this, _Export_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).request: Sending export request.`);
                const currentParameters = __classPrivateFieldGet(this, _Export_sessionEngine, "f").parameterValues;
                const exportParameters = {};
                for (let parameter in currentParameters)
                    exportParameters[parameter] = parameters[parameter] || parameters[parameter] === '' ? parameters[parameter] : currentParameters[parameter];
                __classPrivateFieldGet(this, _Export_logger, "f").info(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).request: Sending export request with parameters ${JSON.stringify(exportParameters)}.`);
                const exportDef = yield __classPrivateFieldGet(this, _Export_sessionEngine, "f").requestExport(this.id, exportParameters, __classPrivateFieldGet(this, _Export_maxWaitTime, "f"));
                this.updateExportDefinition(exportDef);
                const eventEnd = { type: viewer_shared_types_1.TASKTYPE.EXPORT_REQUEST, id: eventId, progress: 1, status: 'Returning export' };
                __classPrivateFieldGet(this, _Export_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_END, eventEnd);
                return exportDef;
            }
            catch (e) {
                const eventEnd = { type: viewer_shared_types_1.TASKTYPE.EXPORT_REQUEST, id: eventId, progress: 1, status: 'Export request failed' };
                __classPrivateFieldGet(this, _Export_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_CANCEL, eventEnd);
                if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                    throw e;
                throw __classPrivateFieldGet(this, _Export_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.EXPORT, `Export(${__classPrivateFieldGet(this, _Export_id, "f")}).request`, e);
            }
        });
    }
    updateExport() {
        const exportDef = __classPrivateFieldGet(this, _Export_sessionEngine, "f").exports[this.id];
        __classPrivateFieldSet(this, _Export_dependency, exportDef.dependency, "f");
        __classPrivateFieldSet(this, _Export_uid, exportDef.uid, "f");
        __classPrivateFieldSet(this, _Export_displayname, exportDef.displayname, "f");
        __classPrivateFieldSet(this, _Export_order, exportDef.order, "f");
        __classPrivateFieldSet(this, _Export_hidden, exportDef.hidden, "f");
        __classPrivateFieldSet(this, _Export_tooltip, exportDef.tooltip, "f");
        __classPrivateFieldSet(this, _Export_version, exportDef.version, "f");
        __classPrivateFieldSet(this, _Export_delay, exportDef.delay, "f");
        __classPrivateFieldSet(this, _Export_content, exportDef.content, "f");
        __classPrivateFieldSet(this, _Export_msg, exportDef.msg, "f");
        __classPrivateFieldSet(this, _Export_filename, exportDef.filename, "f");
        __classPrivateFieldSet(this, _Export_result, exportDef.result, "f");
        __classPrivateFieldSet(this, _Export_status_computation, exportDef.status_computation, "f");
        __classPrivateFieldSet(this, _Export_status_collect, exportDef.status_collect, "f");
        __classPrivateFieldSet(this, _Export_group, exportDef.group, "f");
    }
    // #endregion Public Methods (2)
    // #region Private Methods (1)
    updateExportDefinition(exportDef) {
        __classPrivateFieldSet(this, _Export_dependency, exportDef.dependency, "f");
        __classPrivateFieldSet(this, _Export_uid, exportDef.uid, "f");
        __classPrivateFieldSet(this, _Export_displayname, exportDef.displayname, "f");
        __classPrivateFieldSet(this, _Export_order, exportDef.order, "f");
        __classPrivateFieldSet(this, _Export_hidden, exportDef.hidden, "f");
        __classPrivateFieldSet(this, _Export_tooltip, exportDef.tooltip, "f");
        __classPrivateFieldSet(this, _Export_version, exportDef.version, "f");
        __classPrivateFieldSet(this, _Export_delay, exportDef.delay, "f");
        __classPrivateFieldSet(this, _Export_content, exportDef.content, "f");
        __classPrivateFieldSet(this, _Export_msg, exportDef.msg, "f");
        __classPrivateFieldSet(this, _Export_filename, exportDef.filename, "f");
        __classPrivateFieldSet(this, _Export_result, exportDef.result, "f");
        __classPrivateFieldSet(this, _Export_status_computation, exportDef.status_computation, "f");
        __classPrivateFieldSet(this, _Export_status_collect, exportDef.status_collect, "f");
        __classPrivateFieldSet(this, _Export_group, exportDef.group, "f");
    }
}
exports.Export = Export;
_Export_eventEngine = new WeakMap(), _Export_id = new WeakMap(), _Export_inputValidator = new WeakMap(), _Export_logger = new WeakMap(), _Export_name = new WeakMap(), _Export_session = new WeakMap(), _Export_sessionEngine = new WeakMap(), _Export_type = new WeakMap(), _Export_uuidGenerator = new WeakMap(), _Export_content = new WeakMap(), _Export_delay = new WeakMap(), _Export_dependency = new WeakMap(), _Export_displayname = new WeakMap(), _Export_filename = new WeakMap(), _Export_group = new WeakMap(), _Export_hidden = new WeakMap(), _Export_maxWaitTime = new WeakMap(), _Export_msg = new WeakMap(), _Export_order = new WeakMap(), _Export_result = new WeakMap(), _Export_status_collect = new WeakMap(), _Export_status_computation = new WeakMap(), _Export_tooltip = new WeakMap(), _Export_uid = new WeakMap(), _Export_version = new WeakMap();
//# sourceMappingURL=Export.js.map